import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

/**
 * @returns {Promise<{
 *   settings: null | {
 *     uuid: string,
 *     fromName: string,
 *     fromEmail: string | null,
 *     replyToEmail: string,
 *     facebookUrl: string | null,
 *     instagramUrl: string | null,
 *     xUrl: string | null,
 *     linkedinUrl: string | null,
 *     youTubeUrl: string | null,
 *     webUrl: string | null,
 *     created_at: string,
 *     updated_at: string,
 *     domain: null | {
 *       uuid: string,
 *       domain: string,
 *       dnsRecords: null | {
 *         Name: string,
 *         Type: string,
 *         Value: string,
 *         Note?: string
 *       }[],
 *     },
 *   },
 *   statistics: {
 *     monthlyCap: number,
 *     monthlyCapConsumed: number,
 *     audienceBreakdown: {
 *      businessUsers: Array,
 *      importedContacts: Array, 
 *    }
 *   }
 * }>}
 */
export const getSettings = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/settings`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const checkDomainStatus = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/settings/checkStatus`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveSettings = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/emailCampaigns/settings`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveSettingsSocialLinks = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/emailCampaigns/settings/socials`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};
